module.exports = __webpack_public_path__ + "cat_.png?1c5664acd429f19e86fd4a3c1f58325a";